'use strict';

/* global yith_wcaf */

import { $ } from '../../src/globals.js';
import YITH_WCAF_Admin_Panel from './modules/yith-wcaf-admin-panel';
import YITH_WCAF_Admin_Notes from './modules/yith-wcaf-admin-notes.js';

class YITH_WCAF_Payments extends YITH_WCAF_Admin_Panel {
	constructor() {
		const $containers = $( '#yith_wcaf_panel_commissions-payments' ).add(
			'#yith_wcaf_panel_payment_details'
		);

		super( $containers );

		this.initNotes();
	}

	initNotes() {
		const $container = $( '#payment_notes' ),
			$objectID = $( '#payment_id' );

		if ( ! $container.length || ! $objectID.length ) {
			return;
		}

		new YITH_WCAF_Admin_Notes( $container, 'payment', $objectID.val() );
	}
}

$( () => new YITH_WCAF_Payments() );
